export default "__VITE_ASSET__DeLXEai2__"